import React, { useEffect, useState } from 'react';
import { salidaBodegaPreview, generarSalidaBodega, getProductos, getExistencias } from '../services/api';

// Descuenta de una bodega los productos de una remisión de entrega (salida de inventario).
// Cada línea se mapea a un producto EXISTENTE del catálogo (no se crean productos al salir).
export default function SalidaBodegaModal({ remision, onClose, onFlash }) {
  const [data, setData] = useState(null);
  const [cargando, setCargando] = useState(true);
  const [almacenId, setAlmacenId] = useState('');
  const [rows, setRows] = useState([]);
  const [saving, setSaving] = useState(false);
  const [err, setErr] = useState('');
  const [stockMap, setStockMap] = useState({}); // producto_id -> cantidad en la bodega elegida

  // Carga el stock de la bodega elegida para mostrar "disponibles" por producto.
  useEffect(() => {
    if (!almacenId) return setStockMap({});
    getExistencias({ almacen_id: almacenId })
      .then(({ data }) => { const m = {}; (data || []).forEach(e => { m[e.producto_id] = Number(e.cantidad) || 0; }); setStockMap(m); })
      .catch(() => setStockMap({}));
  }, [almacenId]);
  const stockDe = (id) => Number(stockMap[id] || 0);
  const badgeStock = (stock, need) => {
    const col = stock <= 0 ? { bg: '#7f1d1d', fg: '#fca5a5' } : (need > 0 && stock < need ? { bg: '#78350f', fg: '#fcd34d' } : { bg: '#064e3b', fg: '#6ee7b7' });
    return <span style={{ background: col.bg, color: col.fg, padding: '1px 8px', borderRadius: 10, fontSize: 11, fontWeight: 600, whiteSpace: 'nowrap' }}>{stock} disp.</span>;
  };

  useEffect(() => {
    salidaBodegaPreview(remision.id).then(({ data }) => {
      setData(data);
      const prin = data.almacenes.find(a => a.es_principal) || data.almacenes[0];
      setAlmacenId(prin ? prin.id : '');
      setRows(data.lineas.map(l => ({
        ...l,
        incluir: !l.ya_salida,
        producto: l.sugerido || null,
        buscar: '', opciones: [],
        cantidad: l.cantidad || 1,
      })));
      setCargando(false);
    }).catch(e => { setErr(e.response?.data?.error || 'No se pudo cargar la remisión'); setCargando(false); });
  }, [remision.id]);

  const upd = (i, patch) => setRows(rs => rs.map((r, j) => j === i ? { ...r, ...patch } : r));
  const buscar = async (i, q) => {
    upd(i, { buscar: q, producto: null });
    if (!q || q.trim().length < 2) return upd(i, { opciones: [] });
    try { const { data } = await getProductos(q.trim()); upd(i, { opciones: (data || []).slice(0, 8) }); }
    catch (_) { upd(i, { opciones: [] }); }
  };

  const incluibles = rows.filter(r => r.incluir && !r.ya_salida);
  const guardar = async () => {
    setErr('');
    if (!almacenId) return setErr('Selecciona la bodega de origen');
    const lineas = [];
    for (const r of incluibles) {
      if (!r.producto) continue;
      const cantidad = Number(r.cantidad) || 0;
      if (!cantidad) continue;
      lineas.push({ item_id: r.item_id, producto_id: r.producto.id, cantidad });
    }
    if (!lineas.length) return setErr('No hay líneas listas: elige un producto del catálogo y una cantidad.');
    setSaving(true);
    try {
      const { data } = await generarSalidaBodega(remision.id, { almacen_id: almacenId, lineas });
      if (onFlash) onFlash(true, `✅ ${data.creados} producto(s) descontado(s) de la bodega`);
      onClose();
    } catch (e) { setErr(e.response?.data?.error || 'No se pudo descontar'); setSaving(false); }
  };

  return (
    <div style={s.overlay} onClick={onClose}>
      <div style={{ ...s.modal, width: 860 }} onClick={e => e.stopPropagation()}>
        <h3 style={s.modalTitle}>Sacar de bodega · Remisión {remision.numero}</h3>

        {cargando && <div style={{ color: '#94a3b8', padding: 20 }}>Cargando remisión…</div>}
        {!cargando && data && <>
          {data.almacenes.length === 0
            ? <div style={s.warn}>No tienes bodegas activas. Crea una en Inventario → Almacenes.</div>
            : <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 12, flexWrap: 'wrap' }}>
                <label style={{ ...s.lbl, margin: 0 }}>Bodega de origen:</label>
                <select style={{ ...s.in, width: 'auto', minWidth: 220 }} value={almacenId} onChange={e => setAlmacenId(e.target.value)}>
                  {data.almacenes.map(a => <option key={a.id} value={a.id}>{a.nombre}{a.es_principal ? ' (principal)' : ''}</option>)}
                </select>
                <span style={{ color: '#64748b', fontSize: 12, marginLeft: 'auto' }}>Se descuenta al costo promedio. Si no hay stock suficiente, se avisa.</span>
              </div>}

          <div style={{ ...s.card, maxHeight: '58vh', overflowY: 'auto' }}>
            <table style={s.table}>
              <thead><tr>{['', 'Línea de la remisión', 'Producto en tu catálogo', 'Cant.'].map((h, k) => <th key={k} style={s.th}>{h}</th>)}</tr></thead>
              <tbody>
                {rows.map((r, i) => (
                  <tr key={r.item_id} style={{ opacity: r.incluir && !r.ya_salida ? 1 : 0.5 }}>
                    <td style={s.td}><input type="checkbox" checked={r.incluir && !r.ya_salida} disabled={r.ya_salida} onChange={e => upd(i, { incluir: e.target.checked })} /></td>
                    <td style={{ ...s.td, maxWidth: 260 }}>
                      <div style={{ color: '#e2e8f0' }}>{r.descripcion || <span style={{ color: '#64748b' }}>(sin descripción)</span>}</div>
                      <div style={{ fontSize: 11, color: '#64748b' }}>{r.unidad}{r.ya_salida && <span style={{ color: '#fbbf24' }}> · ya descontada</span>}</div>
                    </td>
                    <td style={{ ...s.td, minWidth: 320 }}>
                      {r.ya_salida ? <span style={{ color: '#64748b' }}>—</span> : (
                        r.producto
                          ? <div style={{ display: 'flex', alignItems: 'center', gap: 8, flexWrap: 'wrap' }}>
                              <span style={{ color: '#cbd5e1', fontSize: 13 }}>{r.producto.codigo ? r.producto.codigo + ' · ' : ''}{r.producto.nombre}</span>
                              {badgeStock(stockDe(r.producto.id), Number(r.cantidad) || 0)}
                              <button type="button" style={s.link} onClick={() => upd(i, { producto: null, buscar: '', opciones: [] })}>cambiar</button>
                            </div>
                          : <div style={{ position: 'relative' }}>
                              <input style={s.in} placeholder="Buscar producto por nombre o código…" value={r.buscar} onChange={e => buscar(i, e.target.value)} />
                              {r.opciones.length > 0 && <div style={s.drop}>
                                {r.opciones.map(o => <div key={o.id} style={{ ...s.dropItem, display: 'flex', justifyContent: 'space-between', gap: 8 }} onClick={() => upd(i, { producto: o, opciones: [], buscar: '' })}>
                                  <span>{o.codigo ? <b>{o.codigo}</b> : ''} {o.nombre}</span>
                                  <span style={{ color: stockDe(o.id) > 0 ? '#6ee7b7' : '#64748b', fontSize: 11, whiteSpace: 'nowrap' }}>{stockDe(o.id)} disp.</span>
                                </div>)}
                              </div>}
                            </div>
                      )}
                    </td>
                    <td style={s.td}><input type="number" step="0.001" style={{ ...s.in, width: 80 }} value={r.cantidad} disabled={r.ya_salida} onChange={e => upd(i, { cantidad: e.target.value })} /></td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </>}

        {err && <div style={{ color: '#fca5a5', fontSize: 13, marginTop: 10 }}>{err}</div>}
        <div style={s.modalBtns}>
          <button style={s.btnGhost} onClick={onClose}>Cerrar</button>
          {!cargando && data && data.almacenes.length > 0 &&
            <button style={s.btn} disabled={saving || incluibles.length === 0} onClick={guardar}>
              {saving ? 'Descontando…' : `Descontar ${incluibles.length} producto(s)`}
            </button>}
        </div>
      </div>
    </div>
  );
}

const s = {
  btn: { background: '#1d4ed8', color: '#fff', border: 'none', borderRadius: 8, padding: '10px 18px', fontSize: 14, fontWeight: 600, cursor: 'pointer' },
  btnGhost: { background: 'transparent', color: '#94a3b8', border: '1px solid #334155', borderRadius: 8, padding: '10px 18px', fontSize: 14, cursor: 'pointer' },
  card: { background: '#1e293b', border: '1px solid #334155', borderRadius: 12, overflow: 'visible' },
  table: { width: '100%', borderCollapse: 'collapse', fontSize: 13 },
  th: { textAlign: 'left', padding: '8px 10px', color: '#64748b', fontSize: 11, textTransform: 'uppercase', letterSpacing: .5, borderBottom: '1px solid #334155', background: '#0f172a', position: 'sticky', top: 0 },
  td: { padding: '8px 10px', color: '#94a3b8', borderBottom: '1px solid #16202e', verticalAlign: 'top' },
  overlay: { position: 'fixed', inset: 0, background: 'rgba(0,0,0,.6)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 50, padding: 16 },
  modal: { background: '#1e293b', border: '1px solid #334155', borderRadius: 12, padding: 18, maxWidth: '96vw', maxHeight: '92vh', overflowY: 'auto', color: '#cbd5e1' },
  modalTitle: { color: '#f1f5f9', fontSize: 17, fontWeight: 700, margin: '0 0 12px' },
  modalBtns: { display: 'flex', justifyContent: 'flex-end', gap: 10, marginTop: 14 },
  lbl: { display: 'block', color: '#94a3b8', fontSize: 12, marginBottom: 5 },
  in: { width: '100%', boxSizing: 'border-box', background: '#0f172a', border: '1px solid #334155', borderRadius: 8, padding: '7px 10px', color: '#f1f5f9', fontSize: 13 },
  link: { background: 'none', border: 'none', color: '#60a5fa', cursor: 'pointer', fontSize: 12, padding: 0 },
  warn: { background: '#3a2c10', color: '#e0a343', fontSize: 13, padding: '10px 14px', borderRadius: 8, marginBottom: 12 },
  drop: { position: 'absolute', zIndex: 5, left: 0, right: 0, top: '100%', background: '#0b1220', border: '1px solid #334155', borderRadius: 8, marginTop: 2, maxHeight: 200, overflowY: 'auto' },
  dropItem: { padding: '7px 10px', fontSize: 13, color: '#cbd5e1', cursor: 'pointer', borderBottom: '1px solid #16202e' },
};
